
export default {
  methods: {
    /**
     * 保持搜索状态页码和当前页时需要拼装的路径方法
     * @param {String} data 需要存入的URL的参数对象
     */
    setPath(data) {
      console.log(data);
      const { path } = this.$route; // push到$router的对象
      this.$router.push({
        path,
        query: data,
      });
    },
    getPath() {
      return this.$route.query;
    },
  },
};
